import { LoadPatientPendencies } from 'domain/usecases/patient/load-patient-pendencies'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteLoadPatientPendencies implements LoadPatientPendencies {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  load(
    params: LoadPatientPendencies.Params
  ): Promise<LoadPatientPendencies.Model> {
    return this.patientRepository.loadPatientPendencies(params)
  }
}
